import { gql } from '@apollo/client';

export const GET_USER_RESOURCE_ACCESS = gql`
  query getUserResourceAccess($userId: String!) {
    getUserResourceAccess(userId: $userId)
      @rest(
        type: "UserResourceAccess"
        path: "/users/{args.userId}/resources"
        endpoint: "admin"
      ) {
      organizations {
        id
        name
        participantType
        isLastOwner
      }
      binders {
        id
        name
        organization {
          id
          name
        }
        participantType
        isLastAdmin
      }
      tenders {
        id
        name
        organization {
          id
          name
        }
        participantType
        isLastAdmin
      }
    }
  }
`;

export type {
  BinderAccessNode,
  ChildResourceAccess,
  OrganizationAccess,
  OrganizationAccessNode,
  ParticipantType,
  TenderAccessNode,
  UserAccessGroups,
  UserResourceAccessResponse
} from './userResourceAccess.types';
